import React from 'react';
import PropTypes from 'prop-types';

import { FileCard } from 'components';

import FilesWithError from './FilesWithError';
import { StyledWrapper } from './style';


const ImportedFileCards = (props) => {
  const {
    imports,
    id: activeImportId,
    percent,
    status,
    processedCount,
    totalCount,
    unprocessedCount,
    geocodedCount,
    indexedCount,
    notFoundCount,
    fileName,
    requiresAddressLookup,
  } = props;
  const activeImportExistsInList = imports.some(item => String(item.id) === String(activeImportId));
  const activeImport = Boolean(activeImportId) && !activeImportExistsInList && Boolean(fileName)
    ? [{
      id: activeImportId,
      fileName,
      percentComplete: percent || 0,
      processedCount,
      totalCount,
      unprocessedCount,
      geocodedCount,
      indexedCount,
      notFoundCount,
      notFoundDatapoints: {
        totalCount: 0,
        nodes: [],
      },
    }]
    : [];
  const importsToRender = [...activeImport, ...imports];

  return (
    <StyledWrapper>
      <FilesWithError imports={imports} />
      {importsToRender.map(({ id, ...datapoints }) => {
        const hasImportNotFoundDatapoints = datapoints.notFoundDatapoints.totalCount > 0;
        const isActiveImport = String(id) === String(activeImportId);
        const shouldRenderCard = hasImportNotFoundDatapoints || isActiveImport;
        const liveProgress = isActiveImport && percent !== undefined ? {
          percent,
          status,
          processedCount,
          totalCount,
          unprocessedCount,
          geocodedCount,
          indexedCount,
          notFoundCount,
          requiresAddressLookup,
        } : null;

        return shouldRenderCard && (
          <FileCard
            key={id}
            id={id}
            isActiveImport={isActiveImport}
            liveProgress={liveProgress}
            {...datapoints}
          />
        );
      })}
    </StyledWrapper>
  );
};

ImportedFileCards.propTypes = {
  imports: PropTypes.array.isRequired,
  pageId: PropTypes.string.isRequired,
  id: PropTypes.string,
  percent: PropTypes.number,
  fileName: PropTypes.string,
  status: PropTypes.string,
  processedCount: PropTypes.number,
  totalCount: PropTypes.number,
  unprocessedCount: PropTypes.number,
  geocodedCount: PropTypes.number,
  indexedCount: PropTypes.number,
  notFoundCount: PropTypes.number,
  requiresAddressLookup: PropTypes.bool,
};

export default ImportedFileCards;
